import { Container } from '@chakra-ui/react'
import { Content } from '@twlvxtwlv/ui/src/components/shared/content'
import { Page } from '@twlvxtwlv/ui/src/components/shared/page'
import { Section } from '@twlvxtwlv/ui/src/components/shared/section'
import { promises as fs } from 'fs'
import type { GetStaticPropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import path from 'path'

interface LegalPageProps {
  content: string
}

export default function LegalPage({ content }: LegalPageProps) {
  const { t } = useTranslation(['common'])

  return (
    <Page bgColor="white">
      <Head>
        <title>{t('meta-title-legal-imprint')}</title>
      </Head>
      <Section>
        <Container maxW="840px">
          <Content content={content} />
        </Container>
      </Section>
    </Page>
  )
}

export async function getStaticProps({ locale = 'de' }: GetStaticPropsContext) {
  const filePath = path.join(process.cwd(), 'public/markdown/imprint.md')
  const content = await fs.readFile(filePath, 'utf8')

  return {
    props: {
      content,
      ...(await serverSideTranslations(locale, ['common', 'navigation', 'footer'])),
    },
  }
}
